import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import fr from './locales/fr.json';
import es from './locales/es.json';

const savedLanguage = localStorage.getItem('preferredLanguage') || 'en';

const languageSettings = [
  { value: 'en', label: 'English', translation: en },
  { value: 'fr', label: 'français', translation: fr },
  { value: 'es', label: 'español', translation: es },
];

const resources = languageSettings.reduce((acc, lang) => {
  acc[lang.value] = { translation: lang.translation };
  return acc;
}, {});

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage,
  fallbackLng: 'en',
  debug: process.env.NODE_ENV === 'development',

  interpolation: {
    escapeValue: false,
  },
});

export const supportedLanguages = languageSettings.map((lang) => ({
  value: lang.value,
  label: lang.label,
}));

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('preferredLanguage', lng);
});

export default i18n;
